import React from 'react'
import {Media} from 'reactstrap'
import MarksmanLogo from '../../../images/marksman-logo.png'
import '../../../stylesheets/Errors.css'

const NotFoundPage = ({location}) =>
    <div className="m-5 text-center">
        <h1>Page not found.</h1>
        <hr/>
        <p>Could not find {location.pathname}</p>
        <Media object src={MarksmanLogo} className="logo-watermark"/>
    </div>

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/components/pages/errors/NotFoundPage.js